import { Component, OnInit, ViewContainerRef, ViewChild } from '@angular/core';
import { CapacityModelService } from "./../services/CapacityModel-Service";
import { ResponseMsg } from "./../common/response-message";
import { ActivatedRoute, Router } from "@angular/router";
import { ValidateDataService } from "./../services/validate-data.service";
import { DetailedQuotaData } from "./../models/cm-model";
import { UserData } from '../shared/models/user.model';
import {
  SohoModalDialogService, SohoBusyIndicatorDirective,
  SohoMessageRef, SohoNotificationService, SohoDatePickerComponent
} from "ids-enterprise-ng";
import { DatePipe } from '@angular/common';
import { AuthHelper } from './../services/authHelper';
import { arePayCurvesEnabled } from './../services/fiscal-year.helper';

@Component({
  selector: 'app-edit-detailed-upload',
  templateUrl: './edit-detailed-upload.component.html',
  styleUrls: ['./edit-detailed-upload.component.css'],
  providers: [DatePipe]
})
export class EditDetailedUploadComponent implements OnInit {
  dialog!: SohoMessageRef;
  @ViewChild(SohoBusyIndicatorDirective, { static: true }) busyIndicator?: SohoBusyIndicatorDirective;
  @ViewChild(SohoDatePickerComponent, { static: true }) datepicker?: SohoDatePickerComponent;
  placeholder!: ViewContainerRef;
  uniqueID: string = "0";
  emailAddress!: string;
  userData = new UserData();

  public normalTooltipText = ResponseMsg.SubCategoryInfo;
  public ManagerMembership = ResponseMsg.ManagerMembership;
  public UserMembership = ResponseMsg.UserMembership;
  public ProductToolTip = ResponseMsg.ProductToolTip;
  public CategoryToolTip = ResponseMsg.CategoryToolTip;
  public SubCategoryToolTip = ResponseMsg.SubCategoryToolTip;
  public ShortDescToolTip = ResponseMsg.ShortDescToolTip;
  public DescriptionToolTip = ResponseMsg.DescriptionToolTip;
  public ApproverIDToolTip = ResponseMsg.ApproverIDToolTip;
  public ProjectTitle = "Edit Detailed Quota";

  isvalid!: boolean;
  public disableAll: boolean = false;

  // Pay curves only exist from environment.payCurveMinFiscalYear onwards, so
  // the pay curve fields are not rendered for earlier fiscal years.
  public showPayCurves: boolean = arePayCurvesEnabled();

  public getTodaysDate!: Date;
  public getDate?: string;

  message = 'Loading...';
  delay = 5;
  transparentOverlay = false;

  public context = this;
  public ObjResponse: any;
  constructor(private capacityModelService: CapacityModelService,
    private validateService: ValidateDataService,
    public model: DetailedQuotaData,
    private modalDialog: SohoModalDialogService,
    private router: Router,
    private route: ActivatedRoute,
    private authhelper: AuthHelper,
    private datePipe: DatePipe,
    private notificationService: SohoNotificationService) { }

  ngOnInit(): void {
    Soho.Locale.set('en-US');
    this.showNotification();
    if(this.route)
    {
      this.route.queryParams.subscribe(params => {
        this.uniqueID = params["uniqueid"];
      });
    }
    this.userData = JSON.parse(localStorage.getItem("userprofile")!);
    if (this.userData!= null && this.userData!=undefined) {     
      this.emailAddress = this.userData.Email;
      this.GetDetailedQuota();
    }    
  }
  start() {
    (this.busyIndicator as any).activated = true;
  }

  stop() {
    (this.busyIndicator as any).activated = false;
  }
  onChange(event: SohoDatePickerEvent) {
    console.log('DatePickerDemoComponent.onChange: type=' + event.target, 'Has originalEvent: ' + (event.originalEvent !== undefined));
  }
  GetDetailedQuota() {
    this.start();
    this.capacityModelService.GetDetailedQuotaForEdit(this.uniqueID, this.emailAddress).subscribe(
      detailedquota => {
        //console.log(quotainput);
        this.model = detailedquota;
        this.model.planstartdate = this.datePipe.transform(this.model.planstartdate, 'MM/dd/yyyy')!;
        this.ProjectTitle = ResponseMsg.EditDetaileQuota + this.model.employeefirstname;
        this.disableAll = true;
        this.stop();
      },
      (error: Response) => {
        this.AddErrorDetails(error);
        this.stop();
      }
    );
  }
  showNotification() {
    this.notificationService.show({
      parent: "#notification",
      message:
        "Use this page to edit the quotas loaded.",
      type: "info",
      linkText: "",
      link: "",
    });
    this.getTodaysDate = new Date();
    this.getDate = this.datePipe.transform(new Date(), 'MM/dd/yyyy')!;
    //$("#btnBusy").trigger('click');
  }
  LoadBusyIndicator() {
    setTimeout((f: any) => this.busyIndicator!.activated = true, 50);
  }
  RemoveError(id: string) {
    $("#" + id).removeMessage().removeError();
  }
  Cancel() {
    //$("#divAddProject").removeClass("is-selected");
    this.router.navigate(["DetailedUpload"]);
  }
  ShowAlert(Message: string, Title: string) {
    const dialogRef1 = this.modalDialog
      .message("<h2>" + Message + "</h2>")
      .buttons(
        [
          {
            text: 'Ok', click: () => {
              dialogRef1.close('Ok');
              this.ResetModel();
              this.router.navigate(["DetailedUpload"]);
            }, isDefault: true
          }
        ])
      .title(Title)
      .open()
      .frameHeight(1000);
  }
  ShowErrorMessage(Message: string, Title: string) {
    const dialogRef1 = this.modalDialog
      .message("<h2>" + Message + "</h2>")
      .buttons(
        [
          {
            text: 'Ok', click: () => {
              dialogRef1.close('Ok');
            }, isDefault: true
          }
        ])
      .title(Title)
      .open()
      .frameHeight(1000);
  }
  ResetModel() {
    let fields: string[] = [
      "planstartdate", 'variablepay', 'plantype', 'territorygroup', 'totalquota', 'variablepaycurrency'
    ];
    for (let objField of fields) {
      $("#" + objField).removeError();
    }

    this.model.uniqueid = 0;
    this.model.managername = "";
    this.model.managerid = 0;
    this.model.employeeid = '';
    this.model.employeefirstname = "";
    this.model.employeelastname = "";
    this.model.lob = "";
    this.model.perpetuallogomultiplier = 0;
    this.model.perpetualmultiplier = 0;
    this.model.saaslogomultiplier = 0;
    this.model.saasmultipliergt3years = 0;
    this.model.saasmultipliergt2lt3years = 0;
    this.model.nclbmultiplier = 0;
    this.model.reprole = "";
    this.model.variabletype = "";
    this.model.holdrecord = false;
    this.model.plantype = "";
    this.model.variablepay = 0;
    this.model.variablepaycurrency = "";
    this.model.perpetualquota = 0;
    this.model.saaslt3yearquota = 0;
    this.model.saasgt3yearquota = 0;
    this.model.totalquota = 0;
    this.model.quotacurrency = "";
    this.model.fiscalyear = '';
    this.model.territorygroup = '';
    this.model.quotacurrency = "";
    this.model.countryname = "";
    this.model.functionalarea = "";
    this.model.department = "";
    this.model.departmentpercrm = "";
    this.model.employeestatus = "";
    this.model.currentyearfxrate = 0;
    this.model.commentsadded = '';
    this.model.processed = false;
    this.model.createdby = "";
    this.model.updatedby = "";
    this.model.territorygroup2 = "";
    this.model.territorygroup3 = "";
    this.model.territorygroup4 = "";
    this.model.territorygroup5 = "";
    this.model.saasmultipliergt1lt2years = 0;
  }
  UpdateDetailedQuotas() {
    this.model.updatedby = this.emailAddress == null ? "krishnaja.atukuri@infor.com" : this.emailAddress;
    this.isvalid = true;
    let errormessage: string;
    errormessage = "";
    let errorFields: string[];
    errorFields = [];
    errorFields = this.validateService.validateFormFields(this.model, ['planstartdate', 'variablepay', 'plantype', 'territorygroup', 'totalquota', 'variablepaycurrency']);
    if (errorFields.length > 0) {
      for (let objField of errorFields) {
        $("#" + objField)
          .removeError()
          .addError({ message: ResponseMsg.Required, showTooltip: true });
        this.isvalid = false;
      }
    }
    if (this.isvalid) {
      errormessage = this.validateService.validateDetailedQuotaForm(this.model)
      if (errormessage.length > 0) {
        this.ShowErrorMessage(errormessage, 'Error');
        this.isvalid = false;
      }
    }
    if (this.isvalid) {
      //this.model.commentsadded='Updated by '+this.emailAddress;
      this.start();
      this.capacityModelService.UpdateDetailedQuotas(this.model).subscribe(
        response => {
          this.stop();
          if (response.status == 200 || response.ErrorMessage == "") {
            // this.ObjResponse = response._body;
            // console.log(response.body.ErrorMessage);
            // console.log(response);
            // if(response.body.ErrorMessage.length>0)
            // this.ShowAlert(response.body.ErrorMessage, "Error Occured");
            // else
            this.ShowAlert("Detailed quota updated successfully.", ResponseMsg.Success);
          } else {
            this.ShowAlert("Error occured", ResponseMsg.ErrorMsg);
          }
        },
        (error: Response) => {
          this.stop();
          this.AddErrorDetails(error);
          this.ShowAlert("Error Occured while updating the Quota.", ResponseMsg.ErrorMsg);
        }
      );
    }
  }
  AddErrorDetails(error: Response) {
    // this.appError.Ok = error.ok;
    // this.appError.Status = error.status;
    // this.appError.StatusText = error.statusText;
    // this.appError.URL = error.url;
    // this.appError.Body = error.json()["ExceptionMessage"];
    // this.projectService.LogErrorDetails(this.appError).subscribe(success => {
    //   console.log("Error details");
    // });
  }
}
